(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('regionService', regionService);

    regionService.$inject = ['$http', 'CONFIG', 'messageService'];

    function regionService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/regions';

        var service = {
            getRegions: getRegions,
            getPageRegions: getPageRegions,
            getRegion: getRegion,
            saveRegion: saveRegion,
            updateRegion: updateRegion,
            deleteRegion: deleteRegion,
            getRegionsByCountry: getRegionsByCountry,
            thereRegionNameByCountry: thereRegionNameByCountry
        }
        return service;

        function getRegions(){
            return $http.get(urlBase + "?detailed=true")
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getPageRegions(page, size){
            return $http.get(urlBase + "/" + 'page?page=' + page + '&size=' + size + '&detailed=true')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getRegion(id){
            return $http.get(urlBase + "/" + id + "?detailed=true")
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function saveRegion(region){
            return $http.post(urlBase, region)
                .then(function(response){
                    messageService.register('regions')
                    return response;
                })
                .catch(function(){
                    messageService.registerError('regions')
                });
        }

        function updateRegion(region, regionId){
            return $http.put(urlBase + "/" + regionId, region)
                .then(function(response){
                    messageService.registerUpdate('regions')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('regions')
                });
        }

        function deleteRegion(id){
            return $http.delete(urlBase + "/" + id)
                .then(function(response){
                    messageService.registerDelete('regions')
                    return response;
                })
                .catch(function(error){
                    if(error.data.message.indexOf('asociación')> -1 || error.data.message.indexOf('asociacion') > -1
                        || error.data.message.indexOf('association') > -1 || error.data.message.indexOf('associated') > -1){
                        messageService.registerDeleteGeneralError('regions','air.region.associatedCities')
                    }else{
                        messageService.registerDeleteError('region')
                    }
                });
        }

        function getRegionsByCountry(countryId){
            return $http.get(urlBase + "/" + countryId + "/countries?active=true")
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.regions : [];
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function thereRegionNameByCountry(name, id){
            return $http.get(urlBase + "/" + id + "/thereRegionName/" + name, {headers: {'Loading-Overlay': false}})
        }
    };

})();
